import { sendChannelClickEvent } from '@/analytics/ga';
import { ChannelGAEvent } from '@/analytics/types';

export class VideoOwnerToolbar {
    sendGaClickEvent(event: Event, eventName: ChannelGAEvent): void {
        sendChannelClickEvent(eventName);
    }
}
